import { useWatch } from "react-hook-form";

import { CourseType } from "@packages/types";

import { CoursePreferencesFormProps } from "~/components/application/ApplicationForm/CoursePreferencesForm";
import { useFindResidencyStatusCountry } from "~/hooks/reference-data";

import { CourseSelectionForm } from "./CourseSelectionForm";
import { createCourseFields } from "./_utils";

export function EnglishCourseSelectionForm(props: CoursePreferencesFormProps) {
  const { control, disabled, setValue, residencyCode } = props;

  const [englishCourse, residencySubStatus] = useWatch({
    control,
    name: ["coursePreferences.englishCourse", "citizenship.residencySubStatus"],
  });

  const campusCountry = useFindResidencyStatusCountry(residencySubStatus);

  return (
    <CourseSelectionForm
      title="Monash English Language Centre Course"
      control={control}
      setValue={setValue}
      fields={createCourseFields("englishCourse")}
      coursePreference={englishCourse}
      residencyCode={residencyCode}
      campusCountry={campusCountry}
      courseType={CourseType.English}
      disabled={disabled}
    />
  );
}
